/* tslint:disable */
/* eslint-disable */
/**
 * A2B Customer API
 * Internal API for customer management
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@a2b-internet.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Account } from '../model';
// @ts-ignore
import type { AccountActivationRequest } from '../model';
// @ts-ignore
import type { AccountCreateRequest } from '../model';
// @ts-ignore
import type { BadRequest } from '../model';
// @ts-ignore
import type { ExtendedAccount } from '../model';
// @ts-ignore
import type { UpdateCustomerAccountRequest } from '../model';
/**
 * CustomerAccountApi - axios parameter creator
 */
export const CustomerAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Activate a new user account
         * @param {string} customerId The customer ID
         * @param {string} accountId The account ID
         * @param {AccountActivationRequest} accountActivationRequest Activation information
         * @param {string} [acceptLanguage] Sets the language for error messages (default en)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateAccount: async (customerId: string, accountId: string, accountActivationRequest: AccountActivationRequest, acceptLanguage?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('activateAccount', 'customerId', customerId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('activateAccount', 'accountId', accountId)
            // verify required parameter 'accountActivationRequest' is not null or undefined
            assertParamExists('activateAccount', 'accountActivationRequest', accountActivationRequest)
            const localVarPath = `/v1/customer/{customerId}/account/{accountId}/activate`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountActivationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new user account
         * @param {string} customerId The customer ID
         * @param {AccountCreateRequest} accountCreateRequest Customer information
         * @param {string} [acceptLanguage] Sets the language for error messages (default en)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: async (customerId: string, accountCreateRequest: AccountCreateRequest, acceptLanguage?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('createAccount', 'customerId', customerId)
            // verify required parameter 'accountCreateRequest' is not null or undefined
            assertParamExists('createAccount', 'accountCreateRequest', accountCreateRequest)
            const localVarPath = `/v1/customer/{customerId}/account`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accountCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a customer account
         * @param {string} customerId The customer ID
         * @param {string} accountId The account ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount: async (customerId: string, accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('deleteAccount', 'customerId', customerId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('deleteAccount', 'accountId', accountId)
            const localVarPath = `/v1/customer/{customerId}/account/{accountId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve account information
         * @param {string} customerId The customer ID
         * @param {string} accountId The account ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount: async (customerId: string, accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getAccount', 'customerId', customerId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccount', 'accountId', accountId)
            const localVarPath = `/v1/customer/{customerId}/account/{accountId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the accounts for the customer
         * @param {string} customerId The customer ID
         * @param {boolean} [all] When set, return all accounts instead of online the active account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: async (customerId: string, all?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getAccounts', 'customerId', customerId)
            const localVarPath = `/v1/customer/{customerId}/account`
                .replace('{customerId}', encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the customer account status and roles
         * @param {string} customerId The customer ID
         * @param {string} accountId The account ID
         * @param {UpdateCustomerAccountRequest} updateCustomerAccountRequest The update request
         * @param {string} [acceptLanguage] Sets the language for error messages (default en)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerAccount: async (customerId: string, accountId: string, updateCustomerAccountRequest: UpdateCustomerAccountRequest, acceptLanguage?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('updateCustomerAccount', 'customerId', customerId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('updateCustomerAccount', 'accountId', accountId)
            // verify required parameter 'updateCustomerAccountRequest' is not null or undefined
            assertParamExists('updateCustomerAccount', 'updateCustomerAccountRequest', updateCustomerAccountRequest)
            const localVarPath = `/v1/customer/{customerId}/account/{accountId}`
                .replace('{customerId}', encodeURIComponent(String(customerId)))
                .replace('{accountId}', encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            if (acceptLanguage != null) {
                localVarHeaderParameter['Accept-Language'] = String(acceptLanguage);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerAccountApi - functional programming interface
 */
export const CustomerAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * Activate a new user account
         * @param {string} customerId The customer ID
         * @param {string} accountId The account ID
         * @param {AccountActivationRequest} accountActivationRequest Activation information
         * @param {string} [acceptLanguage] Sets the language for error messages (default en)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateAccount(customerId: string, accountId: string, accountActivationRequest: AccountActivationRequest, acceptLanguage?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Account>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateAccount(customerId, accountId, accountActivationRequest, acceptLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerAccountApi.activateAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new user account
         * @param {string} customerId The customer ID
         * @param {AccountCreateRequest} accountCreateRequest Customer information
         * @param {string} [acceptLanguage] Sets the language for error messages (default en)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccount(customerId: string, accountCreateRequest: AccountCreateRequest, acceptLanguage?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtendedAccount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccount(customerId, accountCreateRequest, acceptLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerAccountApi.createAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a customer account
         * @param {string} customerId The customer ID
         * @param {string} accountId The account ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccount(customerId: string, accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccount(customerId, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerAccountApi.deleteAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve account information
         * @param {string} customerId The customer ID
         * @param {string} accountId The account ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccount(customerId: string, accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtendedAccount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccount(customerId, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerAccountApi.getAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the accounts for the customer
         * @param {string} customerId The customer ID
         * @param {boolean} [all] When set, return all accounts instead of online the active account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccounts(customerId: string, all?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExtendedAccount>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccounts(customerId, all, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerAccountApi.getAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the customer account status and roles
         * @param {string} customerId The customer ID
         * @param {string} accountId The account ID
         * @param {UpdateCustomerAccountRequest} updateCustomerAccountRequest The update request
         * @param {string} [acceptLanguage] Sets the language for error messages (default en)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerAccount(customerId: string, accountId: string, updateCustomerAccountRequest: UpdateCustomerAccountRequest, acceptLanguage?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtendedAccount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerAccount(customerId, accountId, updateCustomerAccountRequest, acceptLanguage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerAccountApi.updateCustomerAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerAccountApi - factory interface
 */
export const CustomerAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerAccountApiFp(configuration)
    return {
        /**
         * Activate a new user account
         * @param {CustomerAccountApiActivateAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateAccount(requestParameters: CustomerAccountApiActivateAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<Account> {
            return localVarFp.activateAccount(requestParameters.customerId, requestParameters.accountId, requestParameters.accountActivationRequest, requestParameters.acceptLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new user account
         * @param {CustomerAccountApiCreateAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(requestParameters: CustomerAccountApiCreateAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExtendedAccount> {
            return localVarFp.createAccount(requestParameters.customerId, requestParameters.accountCreateRequest, requestParameters.acceptLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a customer account
         * @param {CustomerAccountApiDeleteAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(requestParameters: CustomerAccountApiDeleteAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAccount(requestParameters.customerId, requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve account information
         * @param {CustomerAccountApiGetAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccount(requestParameters: CustomerAccountApiGetAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExtendedAccount> {
            return localVarFp.getAccount(requestParameters.customerId, requestParameters.accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the accounts for the customer
         * @param {CustomerAccountApiGetAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts(requestParameters: CustomerAccountApiGetAccountsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExtendedAccount>> {
            return localVarFp.getAccounts(requestParameters.customerId, requestParameters.all, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the customer account status and roles
         * @param {CustomerAccountApiUpdateCustomerAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerAccount(requestParameters: CustomerAccountApiUpdateCustomerAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExtendedAccount> {
            return localVarFp.updateCustomerAccount(requestParameters.customerId, requestParameters.accountId, requestParameters.updateCustomerAccountRequest, requestParameters.acceptLanguage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activateAccount operation in CustomerAccountApi.
 */
export interface CustomerAccountApiActivateAccountRequest {
    /**
     * The customer ID
     */
    readonly customerId: string

    /**
     * The account ID
     */
    readonly accountId: string

    /**
     * Activation information
     */
    readonly accountActivationRequest: AccountActivationRequest

    /**
     * Sets the language for error messages (default en)
     */
    readonly acceptLanguage?: string
}

/**
 * Request parameters for createAccount operation in CustomerAccountApi.
 */
export interface CustomerAccountApiCreateAccountRequest {
    /**
     * The customer ID
     */
    readonly customerId: string

    /**
     * Customer information
     */
    readonly accountCreateRequest: AccountCreateRequest

    /**
     * Sets the language for error messages (default en)
     */
    readonly acceptLanguage?: string
}

/**
 * Request parameters for deleteAccount operation in CustomerAccountApi.
 */
export interface CustomerAccountApiDeleteAccountRequest {
    /**
     * The customer ID
     */
    readonly customerId: string

    /**
     * The account ID
     */
    readonly accountId: string
}

/**
 * Request parameters for getAccount operation in CustomerAccountApi.
 */
export interface CustomerAccountApiGetAccountRequest {
    /**
     * The customer ID
     */
    readonly customerId: string

    /**
     * The account ID
     */
    readonly accountId: string
}

/**
 * Request parameters for getAccounts operation in CustomerAccountApi.
 */
export interface CustomerAccountApiGetAccountsRequest {
    /**
     * The customer ID
     */
    readonly customerId: string

    /**
     * When set, return all accounts instead of online the active account
     */
    readonly all?: boolean
}

/**
 * Request parameters for updateCustomerAccount operation in CustomerAccountApi.
 */
export interface CustomerAccountApiUpdateCustomerAccountRequest {
    /**
     * The customer ID
     */
    readonly customerId: string

    /**
     * The account ID
     */
    readonly accountId: string

    /**
     * The update request
     */
    readonly updateCustomerAccountRequest: UpdateCustomerAccountRequest

    /**
     * Sets the language for error messages (default en)
     */
    readonly acceptLanguage?: string
}

/**
 * CustomerAccountApi - object-oriented interface
 */
export class CustomerAccountApi extends BaseAPI {
    /**
     * Activate a new user account
     * @param {CustomerAccountApiActivateAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public activateAccount(requestParameters: CustomerAccountApiActivateAccountRequest, options?: RawAxiosRequestConfig) {
        return CustomerAccountApiFp(this.configuration).activateAccount(requestParameters.customerId, requestParameters.accountId, requestParameters.accountActivationRequest, requestParameters.acceptLanguage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new user account
     * @param {CustomerAccountApiCreateAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createAccount(requestParameters: CustomerAccountApiCreateAccountRequest, options?: RawAxiosRequestConfig) {
        return CustomerAccountApiFp(this.configuration).createAccount(requestParameters.customerId, requestParameters.accountCreateRequest, requestParameters.acceptLanguage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a customer account
     * @param {CustomerAccountApiDeleteAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAccount(requestParameters: CustomerAccountApiDeleteAccountRequest, options?: RawAxiosRequestConfig) {
        return CustomerAccountApiFp(this.configuration).deleteAccount(requestParameters.customerId, requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve account information
     * @param {CustomerAccountApiGetAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAccount(requestParameters: CustomerAccountApiGetAccountRequest, options?: RawAxiosRequestConfig) {
        return CustomerAccountApiFp(this.configuration).getAccount(requestParameters.customerId, requestParameters.accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the accounts for the customer
     * @param {CustomerAccountApiGetAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAccounts(requestParameters: CustomerAccountApiGetAccountsRequest, options?: RawAxiosRequestConfig) {
        return CustomerAccountApiFp(this.configuration).getAccounts(requestParameters.customerId, requestParameters.all, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the customer account status and roles
     * @param {CustomerAccountApiUpdateCustomerAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCustomerAccount(requestParameters: CustomerAccountApiUpdateCustomerAccountRequest, options?: RawAxiosRequestConfig) {
        return CustomerAccountApiFp(this.configuration).updateCustomerAccount(requestParameters.customerId, requestParameters.accountId, requestParameters.updateCustomerAccountRequest, requestParameters.acceptLanguage, options).then((request) => request(this.axios, this.basePath));
    }
}

